import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackingDataActions from '../../actions/trackingDataActions';
import * as appHelper from '../../helpers/appHelper';
import * as userDataHelper from '../../helpers/userDataHelper';
import * as keyboardConstants from '../../constants/keyboardConstants';
import * as objectConstants from '../../constants/objectConstants';
import * as componentConstants from '../../constants/componentConstants';
import * as environmentHelper from '../../helpers/environmentHelper';


class HomeHeaderButton extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            label: appHelper.getLocaleString("home_label"),
            env: environmentHelper.getEnvironment(),
        };
        this.onHomeClick = this.onHomeClick.bind(this);
        this.setIconClass = this.setIconClass.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.showHomeBtn = this.showHomeBtn.bind(this);
        this.setBtnClass = this.setBtnClass.bind(this);
        this.isEnabled = this.isEnabled.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                label: appHelper.getLocaleString("home_label"),
            });
        }
    }

    onHomeClick(e) {
        e.preventDefault();
        e.stopPropagation();
        if(this.isEnabled()) {
            this.context.router.push(`menu`);
        }
    }

    setIconClass(){
        return "icons8-undo";
    }

    setKeyboardAccessibility(event){
        if(event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY){
            event.preventDefault();
            this.onHomeClick();
        }
    }

    showHomeBtn(){
        let showHomeBtn = false;
        if(this.props.contentData.experience.bites.length > 1 && this.props.contentData.experience.experience_learning_model === componentConstants.MENU_TYPE_PERSONAL_LEARNING_PLAN && userDataHelper.getBiteStatus(this.props.userData.bites[0]) === objectConstants.STATUS_COMPLETE){
            showHomeBtn = true;
        }else if(this.props.contentData.experience.bites.length > 1 && this.props.contentData.experience.experience_learning_model !== componentConstants.MENU_TYPE_PERSONAL_LEARNING_PLAN){
            showHomeBtn = true;
        }
        return showHomeBtn;
    }

    setBtnClass(){
        return !this.isEnabled() ? 'disabled' : '';
    }

    isEnabled(){
        return userDataHelper.getBiteStatus(this.props.userData.bites[0]) === objectConstants.STATUS_COMPLETE;
    }

    render() {
        return (
            this.showHomeBtn()
                ?
                (appHelper.isDefined(this.props.contentData.experience.show_icons) && this.props.contentData.experience.show_icons) || !appHelper.isDefined(this.props.contentData.experience.show_icons) || this.state.env.isDevice
                    ?
                    <div className={`header-btn home ${this.setBtnClass()}`} onClick={this.onHomeClick} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex="0" aria-controls="home" title={this.state.label} >
                        <div className={`icon icons8-home `}/>
                        <div className="btn-label">{this.state.label}</div>
                    </div>
                    :
                    <div className={`header-btn ${this.setBtnClass()}`} onClick={this.onHomeClick} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex="0" aria-controls="home" title={this.state.label} >
                        <div className="nav-label">{this.state.label}</div>
                    </div>
                :
                null



        );
    }
}

HomeHeaderButton.propTypes = {
    lang: PropTypes.string.isRequired,
    userData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired

};

HomeHeaderButton.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData,

        contentData: state.contentData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({},trackingDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(HomeHeaderButton);



/** WEBPACK FOOTER **
 ** ./src/components/buttons/HomeHeaderButton.js
 **/